<template>
  <div class="jsontools">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>JSON 格式化 / 比对</span>
        <el-button style="float: right; padding: 3px 10px" type="text" @click="mode = 'format'">格式化</el-button>
        <el-button style="float: right; padding: 3px 10px" type="text" @click="mode = 'diff'">比对</el-button>
      </div>

      <!-- 格式化模式 -->
      <div v-if="mode === 'format'">
        <el-row :gutter="10" style="margin-bottom: 10px">
          <el-col :span="24">
            <el-button type="primary" size="small" @click="formatJson">格式化</el-button>
            <el-button size="small" @click="compressJson">压缩</el-button>
            <el-button size="small" @click="clearFormat">清空</el-button>
          </el-col>
        </el-row>
        <el-input
          type="textarea"
          :rows="15"
          v-model="jsonInput"
          placeholder="粘贴JSON内容..."
          style="font-family: monospace"
        ></el-input>
        <el-divider></el-divider>
        <div v-if="formatError" class="error-message">
          <el-alert :title="formatError" type="error" :closable="false"></el-alert>
        </div>
        <pre v-if="jsonOutput" class="json-output">{{ jsonOutput }}</pre>
      </div>

      <!-- 比对模式 -->
      <div v-if="mode === 'diff'">
        <el-row :gutter="10" style="margin-bottom: 10px">
          <el-col :span="24">
            <el-button type="primary" size="small" @click="compareJson">比对</el-button>
            <el-button size="small" @click="clearDiff">清空</el-button>
            <span style="margin-left: 20px; color: #67C23A">绿色：新增</span>
            <span style="margin-left: 10px; color: #F56C6C">红色：删除</span>
            <span style="margin-left: 10px; color: #409EFF">蓝色：修改</span>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <div class="diff-header">JSON 1 (原始)</div>
            <el-input
              type="textarea"
              :rows="15"
              v-model="json1"
              placeholder="粘贴第一个JSON..."
              style="font-family: monospace"
            ></el-input>
          </el-col>
          <el-col :span="12">
            <div class="diff-header">JSON 2 (新)</div>
            <el-input
              type="textarea"
              :rows="15"
              v-model="json2"
              placeholder="粘贴第二个JSON..."
              style="font-family: monospace"
            ></el-input>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <div v-if="diffError" class="error-message">
          <el-alert :title="diffError" type="error" :closable="false"></el-alert>
        </div>
        <div v-if="diffResult && diffResult.length > 0" class="diff-result">
          <div class="diff-header">差异结果</div>
          <div v-for="(item, index) in diffResult" :key="index" class="diff-item" :class="item.type">
            <span class="diff-path">{{ item.path }}</span>
            <span class="diff-value">{{ item.value }}</span>
          </div>
        </div>
        <div v-if="diffResult && diffResult.length === 0 && !diffError" class="no-diff">
          <el-alert title="两个JSON完全一致" type="success" :closable="false"></el-alert>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'jsontools',
  data () {
    return {
      mode: 'format',
      jsonInput: '',
      jsonOutput: '',
      formatError: '',
      json1: '',
      json2: '',
      diffError: '',
      diffResult: []
    }
  },
  methods: {
    formatJson () {
      this.formatError = ''
      this.jsonOutput = ''
      try {
        const parsed = JSON.parse(this.jsonInput)
        this.jsonOutput = JSON.stringify(parsed, null, 2)
      } catch (e) {
        this.formatError = 'JSON格式错误: ' + e.message
      }
    },
    compressJson () {
      this.formatError = ''
      this.jsonOutput = ''
      try {
        const parsed = JSON.parse(this.jsonInput)
        this.jsonOutput = JSON.stringify(parsed)
      } catch (e) {
        this.formatError = 'JSON格式错误: ' + e.message
      }
    },
    clearFormat () {
      this.jsonInput = ''
      this.jsonOutput = ''
      this.formatError = ''
    },
    compareJson () {
      this.diffError = ''
      this.diffResult = []
      try {
        const obj1 = JSON.parse(this.json1)
        const obj2 = JSON.parse(this.json2)
        this.diffResult = this.deepDiff(obj1, obj2)
      } catch (e) {
        this.diffError = 'JSON格式错误: ' + e.message
      }
    },
    deepDiff (obj1, obj2, path = '') {
      const result = []
      const keys1 = Object.keys(obj1 || {})
      const keys2 = Object.keys(obj2 || {})
      const allKeys = [...new Set([...keys1, ...keys2])]

      for (const key of allKeys) {
        const currentPath = path ? `${path}.${key}` : key
        const val1 = obj1 ? obj1[key] : undefined
        const val2 = obj2 ? obj2[key] : undefined

        if (!(key in (obj1 || {}))) {
          result.push({ type: 'added', path: currentPath, value: JSON.stringify(val2) })
        } else if (!(key in (obj2 || {}))) {
          result.push({ type: 'removed', path: currentPath, value: JSON.stringify(val1) })
        } else if (typeof val1 === 'object' && typeof val2 === 'object') {
          result.push(...this.deepDiff(val1, val2, currentPath))
        } else if (JSON.stringify(val1) !== JSON.stringify(val2)) {
          result.push({ 
            type: 'modified', 
            path: currentPath, 
            value: `${JSON.stringify(val1)} → ${JSON.stringify(val2)}` 
          })
        }
      }
      return result
    },
    clearDiff () {
      this.json1 = ''
      this.json2 = ''
      this.diffResult = []
      this.diffError = ''
    }
  }
}
</script>

<style scoped>
.jsontools {
  padding: 20px;
  max-width: 1600px;
  margin: 0 auto;
}
.box-card {
  max-width: 1600px;
  margin: 0 auto;
}
.json-output {
  background: #f5f7fa;
  padding: 15px;
  border-radius: 4px;
  text-align: left;
  overflow-x: auto;
  max-height: 500px;
  font-family: monospace;
  font-size: 13px;
  white-space: pre-wrap;
  word-break: break-all;
}
.error-message {
  margin-bottom: 15px;
}
.diff-header {
  font-weight: bold;
  margin-bottom: 5px;
  color: #409EFF;
}
.diff-result {
  max-height: 500px;
  overflow-y: auto;
}
.diff-item {
  padding: 8px 12px;
  margin-bottom: 5px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 13px;
}
.diff-item.added {
  background: #f0f9eb;
  color: #67C23A;
}
.diff-item.removed {
  background: #fef0f0;
  color: #F56C6C;
}
.diff-item.modified {
  background: #ecf5ff;
  color: #409EFF;
}
.diff-path {
  font-weight: bold;
  margin-right: 10px;
}
.diff-value {
  word-break: break-all;
}
.no-diff {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/jsontools.vue